/**
 * @file profiles.api.js
 * @module ProfilesAPI
 * @description HTTP API wrapper for profile related endpoints. Methods return Axios promises.
 */

import { axiosInstance } from "./axios";

export const ProfilesAPI = {
    /**
     * Update user profile data.
     * @param {string} userId - User identifier.
     * @param {Object} user - Partial or full user profile payload.
     * @param {string} [token=""] - Optional authentication token.
     * @returns {Promise} Axios promise resolving to updated profile.
     */
    updateProfile: (userId, user, token = "") => {
        return axiosInstance(token).patch(`/profile/users/${userId}`, user);
    },

    /**
     * Get profile for a user.
     * @param {string} userId - User identifier.
     * @param {string} [token=""] - Optional authentication token.
     * @returns {Promise} Axios promise resolving to profile data.
     */
    getProfileUser: (userId, token = "") => {
        return axiosInstance(token).get(`/users/${userId}/profile`);
    }
}
